import cashDeskPublicInstance from './instance'

const getClientMonitorPublicConfig = () => {
	return cashDeskPublicInstance.get('/publicClientMonitorConfig')
}

export default getClientMonitorPublicConfig
